[
  {
    "pageName": "Dashboard",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/landing-page",
    "icon": "landing-page",
    "ref": "landing-page",
    "menuGroup": "menu"
  },
  {
    "pageName": "Noise Word Handling",
    "hasChildren": true,
    "isActive": true,
    "route": "/main/noise-management",
    "icon": "ebook-repository",
    "ref": "noise-management",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Noise Word Library",
        "ref": "noise-management/noise-dictionary-list",
        "route": "/main/noise-management/noise-dictionary-list"
      },
      {
        "pageName": "Noise Logs",
        "ref": "noise-management/noise-word-logs",
        "route": "/main/noise-management/noise-word-logs"
      }
    ]
  },
  {
    "pageName": "Avatar Configuration",
    "hasChildren": true,
    "isActive": true,
    "route": "/main/avatar-configuration",
    "icon": "configuration",
    "ref": "avatar-configuration",
    "menuGroup": "pages",
    "children": [
      {
        "pageName": "Knowledge Base",
        "ref": "avatar-configuration/knowledge-base",
        "route": "/main/avatar-configuration/knowledge-base"
      },
      {
        "pageName": "Knowledge Sources",
        "ref": "avatar-configuration/knowledge-sources",
        "route": "/main/avatar-configuration/knowledge-sources"
      },
      {
        "pageName": "Personalization",
        "ref": "avatar-configuration/personalization",
        "route": "/main/avatar-configuration/personalization"
      },
      {
        "pageName": "Conversation Mode",
        "ref": "conversation-mode",
        "route": "/main/conversation-mode"
      },
      {
        "pageName": "Avatar Settings",
        "ref": "avatar-configuration/speech",
        "route": "/main/avatar-configuration/speech"
      },
      {
        "pageName": "Camera Settings",
        "ref": "camera-settings",
        "route": "/main/camera-settings"
      },
      {
        "pageName": "Playlist & Video",
        "ref": "playlists-videos-configuration",
        "route": "/main/playlists-videos-configuration"
      }
    ]
  },
  {
    "pageName": "User Management",
    "hasChildren": true,
    "route": null,
    "isActive": true,
    "icon": "user-management",
    "ref": "user-management",
    "menuGroup": "general",
    "children": [
      {
        "pageName": "User",
        "ref": "user-management/user-list",
        "route": "/main/user-management/user-list"
      },
      {
        "pageName": "Role",
        "ref": "user-management/roles",
        "route": "/main/user-management/roles"
      },
      {
        "pageName": "User Role Mapping",
        "ref": "user-management/user-role-mapping",
        "route": "/main/user-management/user-role-mapping"
      }
    ]
  },
  {
    "pageName": "Out of Scope",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/out-of-scope",
    "icon": "out-of-scope",
    "ref": "out-of-scope",
    "menuGroup": "pages"
  },
  {
    "pageName": "Session Drop-Off",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/session-drop-off",
    "icon": "analytics",
    "ref": "session-drop-off",
    "menuGroup": "pages"
  },
  {
    "pageName": "User Experience",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/user-experience",
    "icon": "analytics",
    "ref": "user-experience",
    "menuGroup": "pages"
  },
  {
    "pageName": "Reported Messages",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/reported-messages",
    "icon": "system-reports",
    "ref": "reported-messages",
    "menuGroup": "pages"
  },
  {
    "pageName": "Playlists",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/playlists",
    "icon": "playlists",
    "ref": "playlists",
    "menuGroup": "pages"
  },
  {
    "pageName": "Channel Management",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/channel-management",
    "icon": "channel-management",
    "ref": "channel-management",
    "menuGroup": "pages"
  },
  {
    "pageName": "Trending Topics",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/trending-topics",
    "icon": "analytics",
    "ref": "trending-topics",
    "menuGroup": "pages"
  },
  {
    "pageName": "FAQ Management",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/faq-management",
    "icon": "info-circle",
    "ref": "faq-management",
    "menuGroup": "pages"
  },
  {
    "pageName": "Knowledge Base",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/context-management",
    "icon": "ebook-repository",
    "ref": "context-management",
    "menuGroup": "pages"
  },
  {
    "pageName": "Document Links",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/knowledge-intake",
    "icon": "case-management",
    "ref": "knowledge-intake",
    "menuGroup": "pages"
  },
  {
    "pageName": "User Logging",
    "hasChildren": false,
    "isActive": true,
    "route": "/main/user-logging",
    "icon": "fatca-reporting",
    "ref": "user-logging",
    "menuGroup": "general"
  },
  {
    "pageName": "Audit Trail",
    "hasChildren": false,
    "route": "/main/audit-trail",
    "icon": "audit-trail",
    "ref": "audit-trail",
    "menuGroup": "general"
  }
]
